import React from 'react';
import { EarthquakeHeroHeader } from '../../components/landing/EarthquakeHeroHeader';

interface EarthquakeLandingViewProps {
  onGoToRegistration: () => void;
}

export const EarthquakeLandingView: React.FC<EarthquakeLandingViewProps> = ({
  onGoToRegistration,
}) => {
  return (
    <div className="min-h-screen bg-blue-900 flex flex-col justify-between selection:bg-red-500 selection:text-white font-sans">
      {/* Top Navbar */}
      <header className="w-full bg-blue-950/70 backdrop-blur-md border-b border-blue-800/60 sticky top-0 z-40 px-4 sm:px-8 py-3.5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-red-600 flex items-center justify-center text-white font-black text-lg shadow-sm">
            C
          </div>
          <span className="font-bold text-white text-sm sm:text-base tracking-tight">
            Ciencuadras <span className="text-red-400 font-medium">| Vivienda</span>
          </span>
        </div>

        <button
          onClick={onGoToRegistration}
          className="px-4 py-2 text-xs sm:text-sm font-semibold rounded-lg bg-red-600 hover:bg-red-500 text-white transition-colors shadow-sm cursor-pointer"
        >
          Accede a nuestra aplicación
        </button>
      </header>

      {/* Main Single-Screen Hero */}
      <main className="flex-1 flex flex-col justify-center">
        <EarthquakeHeroHeader onAccessClick={onGoToRegistration} />
      </main>

      {/* Simple Subdued Footer */}
      <footer className="bg-blue-950 border-t border-blue-800/60 text-blue-200/80 py-4 px-4 text-center text-xs">
        <div className="max-w-4xl mx-auto flex items-center justify-center">
          <span>Ciencuadras y Davivienda — Programa de Apoyo a la Vivienda</span>
        </div>
      </footer>
    </div>
  );
};
